import React from 'react'
import './style.scss'

const Separator = ({ textColor }) => {
  return (
    <div className="separator">
      <div
        className="separator-dot"
        style={{
          backgroundColor: textColor,
        }}
      />
      <div
        className="separator-dot"
        style={{
          backgroundColor: textColor,
        }}
      />
    </div>
  )
}

const Digit = ({ digit, bgColor, textColor }) => {
  return (
    <div
      className="digit"
      style={{
        backgroundColor: bgColor,
      }}
    >
      <span
        style={{
          color: textColor,
        }}
      >
        {digit}
      </span>
    </div>
  )
}

const Timer = ({ time, bgColor, textColor }) => {
  return (
    <div className="timer">
      <Digit digit={time[0]} bgColor={bgColor} textColor={textColor} />
      <Separator textColor={textColor} />
      <Digit digit={time[1]} bgColor={bgColor} textColor={textColor} />
      <Separator textColor={textColor} />
      <Digit digit={time[2]} bgColor={bgColor} textColor={textColor} />
    </div>
  )
}

export default Timer
